import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
  }
`;

export const Content = styled.div`
  background: white;
  border-radius: 20px;
  padding: 3rem 2rem;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
    border-radius: 15px;
    margin: 0 1rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem 1rem;
    border-radius: 10px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    margin: 0 1rem;
  }
`;

export const Icon = styled.div`
  font-size: 5rem;
  margin-bottom: 1.5rem;
  animation: bounce 2s ease-in-out infinite;

  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  @media (max-width: 768px) {
    font-size: 4rem;
    margin-bottom: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 3rem;
    margin-bottom: 0.75rem;
  }
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.75rem;
    margin-bottom: 0.75rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-bottom: 1rem;
    line-height: 1.5;
  }
`;

export const InfoBox = styled.div`
  background: #f8f9fa;
  border-radius: 10px;
  padding: 1.5rem;
  margin-top: 2rem;
  text-align: left;
  border: 1px solid #e9ecef;
  font-size: 1.2rem;

  @media (max-width: 768px) {
    padding: 1.25rem;
    margin-top: 1.5rem;
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    margin-top: 1rem;
    font-size: 0.9rem;
    border-radius: 8px;
  }
`;

export const InfoLabel = styled.div`
  font-size: 1rem;
  color: #6c757d;
  font-weight: 600;
  margin-top: 0.75rem;

  &:first-child {
    margin-top: 0;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
    margin-top: 0.5rem;
  }
`;

export const InfoValue = styled.div`
  font-size: 1.2rem;
  color: #212529;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

export const Logo = styled.img`
  max-width: 200px;
  height: auto;
  z-index: 1;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    max-width: 150px;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    max-width: 120px;
    margin-bottom: 1rem;
  }
`;
